{
  "login": {
    "title": "เข้าสู่ระบบ",
    "intro": "บัญชีพนักงานสำหรับหลังบ้านของร้าน",
    "email": "อีเมล",
    "password": "รหัสผ่าน",
    "show_password": "แสดงรหัสผ่าน",
    "hide_password": "ซ่อนรหัสผ่าน",
    "caps_lock": "เปิด Caps Lock อยู่",
    "submit": "เข้าสู่ระบบ",
    "submitting": "กำลังเข้าสู่ระบบ…",
    "forgot": "ลืมรหัสผ่าน?",
    "dev_bypass_hint": "โหมดพัฒนา: ใส่อีเมลและรหัสผ่านอะไรก็เข้าได้"
  },
  "totp": {
    "title": "ใส่รหัส 6 หลัก",
    "intro": "เปิดแอปยืนยันตัวตน (Google Authenticator, 1Password…) แล้วพิมพ์รหัสของร้านนี้",
    "code": "รหัส 6 หลัก",
    "submit": "ต่อไป",
    "use_recovery": "ใช้รหัสสำรองแทน",
    "use_app": "ใช้รหัสจากแอป",
    "recovery_code": "รหัสสำรอง",
    "recovery_intro": "พิมพ์รหัสสำรองหนึ่งรหัสที่พิมพ์หรือเก็บไว้ตอนตั้งค่าแอป แต่ละรหัสใช้ได้ครั้งเดียว",
    "back": "กลับไปหน้าเข้าสู่ระบบ"
  },
  "setup": {
    "title": "ป้องกันบัญชีด้วยแอปรหัส",
    "intro": "เจ้าของร้านและผู้จัดการต้องยืนยันอีกขั้นตอนตอนเข้าสู่ระบบ ใช้เวลาประมาณ 2 นาที",
    "step1_title": "1. ติดตั้งแอปยืนยันตัวตน",
    "step1_body": "ติดตั้ง Google Authenticator, Microsoft Authenticator หรือ 1Password (ฟรีทั้งหมด) บนมือถือ",
    "step2_title": "2. สแกนรูปนี้ด้วยแอป",
    "step2_body": "ในแอป กด \"+\" แล้วเลือก \"สแกน QR code\"",
    "qr_alt": "QR code สำหรับเพิ่มร้านนี้ในแอปยืนยันตัวตน",
    "manual": "สแกนไม่ได้? พิมพ์คีย์นี้ในแอปแทน:",
    "copy_secret": "คัดลอกคีย์",
    "copied": "คัดลอกแล้ว",
    "step3_title": "3. พิมพ์รหัส 6 หลักที่แอปแสดง",
    "code": "รหัส 6 หลัก",
    "submit": "ตรวจรหัส",
    "loading": "กำลังเตรียม QR code…",
    "codes_title": "เก็บรหัสสำรองไว้",
    "codes_intro": "ถ้ามือถือหาย รหัสแต่ละตัวใช้เข้าสู่ระบบได้ครั้งเดียว ดาวน์โหลดแล้วเก็บไว้ในที่ปลอดภัย (ไม่ใช่มือถือเครื่องเดียวกัน)",
    "download": "ดาวน์โหลดรหัสสำรอง",
    "print": "พิมพ์",
    "downloaded": "ดาวน์โหลดแล้ว — เก็บไฟล์ไว้ในที่ปลอดภัย",
    "must_download": "ดาวน์โหลดรหัสสำรองก่อน — จะไม่แสดงอีก",
    "confirm_saved": "ฉันเก็บรหัสสำรองแล้ว",
    "continue": "ไปที่หลังบ้านร้าน",
    "file_heading": "รหัสสำรองของหลังบ้านร้าน — แต่ละรหัสใช้ได้ครั้งเดียว",
    "done": "เปิดการเข้าสู่ระบบ 2 ขั้นตอนแล้ว"
  },
  "change": {
    "title": "ตั้งรหัสผ่านใหม่",
    "intro": "นี่คือการเข้าสู่ระบบครั้งแรกด้วยรหัสผ่านชั่วคราว ตั้งรหัสผ่านของคุณเองเพื่อไปต่อ",
    "current": "รหัสผ่านชั่วคราว",
    "current_profile": "รหัสผ่านปัจจุบัน",
    "new": "รหัสผ่านใหม่",
    "confirm": "รหัสผ่านใหม่อีกครั้ง",
    "submit": "บันทึกรหัสผ่านใหม่",
    "mismatch": "รหัสผ่านใหม่ทั้งสองช่องไม่ตรงกัน",
    "saved": "เปลี่ยนรหัสผ่านแล้ว อุปกรณ์อื่นถูกออกจากระบบ"
  },
  "strength": {
    "label": "ความแข็งแรงของรหัสผ่าน",
    "rule": "อย่างน้อย 12 ตัวอักษร ใช้ประโยคสั้นๆ จะจำง่าย",
    "too_short": "สั้นเกินไป — ขาดอีก {{count}} ตัว",
    "weak": "อ่อน",
    "fair": "พอใช้",
    "strong": "แข็งแรง"
  },
  "forgot": {
    "title": "ตั้งรหัสผ่านใหม่",
    "intro": "พิมพ์อีเมลของบัญชีพนักงาน ระบบจะส่งลิงก์สำหรับตั้งรหัสผ่านใหม่",
    "email": "อีเมล",
    "submit": "ส่งลิงก์",
    "sent_title": "ตรวจอีเมลของคุณ",
    "sent_body": "ถ้าอีเมลนี้เป็นบัญชีพนักงาน ลิงก์กำลังส่งไป ใช้ได้ 30 นาที",
    "back": "กลับไปหน้าเข้าสู่ระบบ"
  },
  "reset": {
    "title": "ตั้งรหัสผ่านใหม่",
    "missing_token": "ลิงก์นี้ไม่ครบ เปิดลิงก์จากอีเมลอีกครั้ง หรือขอลิงก์ใหม่",
    "submit": "บันทึกรหัสผ่านใหม่",
    "done_title": "บันทึกรหัสผ่านแล้ว",
    "done_body": "เข้าสู่ระบบด้วยรหัสผ่านใหม่ได้เลย",
    "sign_in": "เข้าสู่ระบบ",
    "ask_again": "ขอลิงก์ใหม่"
  },
  "expired": {
    "title": "หมดเวลา กรุณาเข้าสู่ระบบอีกครั้ง",
    "body": "เพื่อความปลอดภัย ระบบให้ออกจากระบบแล้ว สิ่งที่กรอกในหน้านี้ถูกเก็บเป็นร่างและจะกลับมาหลังเข้าสู่ระบบ",
    "sign_in": "เข้าสู่ระบบอีกครั้ง"
  },
  "profile": {
    "title": "บัญชีของฉัน",
    "intro": "การเข้าสู่ระบบ ภาษา และอุปกรณ์ของคุณ",
    "details": "ข้อมูลของฉัน",
    "name": "ชื่อ",
    "role": "บทบาท",
    "language": "ภาษาของหลังบ้าน",
    "language_hint": "ใช้เฉพาะคุณ พนักงานคนอื่นใช้ภาษาของตัวเอง บันทึกไว้ในเครื่องนี้",
    "language_saved": "เปลี่ยนภาษาแล้ว",
    "password_title": "รหัสผ่าน",
    "password_change": "เปลี่ยนรหัสผ่าน",
    "password_saved": "เปลี่ยนรหัสผ่านแล้ว อุปกรณ์อื่นถูกออกจากระบบ",
    "two_step": "เข้าสู่ระบบ 2 ขั้นตอน (แอปรหัส)",
    "two_step_on": "เปิด",
    "two_step_off": "ปิด",
    "two_step_turn_on": "เปิดใช้",
    "sessions_title": "อุปกรณ์ที่เข้าสู่ระบบอยู่",
    "sessions_intro": "ทุกเบราว์เซอร์หรือมือถือที่เปิดบัญชีของคุณอยู่",
    "this_device": "เครื่องนี้",
    "last_used": "ใช้ล่าสุด {{time}}",
    "signed_in_at": "เข้าสู่ระบบ {{time}}",
    "unknown_device": "เบราว์เซอร์ที่ไม่รู้จัก",
    "sign_out_others": "ออกจากระบบทุกเครื่องอื่น",
    "sign_out_others_title": "ออกจากระบบทุกเครื่องอื่น?",
    "sign_out_others_body": "เบราว์เซอร์และมือถืออื่นทั้งหมดต้องเข้าสู่ระบบใหม่ เครื่องนี้ยังอยู่ในระบบ",
    "signed_out_others_other": "ออกจากระบบอีก {{count}} เครื่องแล้ว",
    "no_other_sessions": "ไม่มีเครื่องอื่น"
  },
  "errors": {
    "invalid": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    "not_available": "ยังไม่ได้เชื่อมต่อการเข้าสู่ระบบ บัญชีพนักงานจะมาพร้อมระบบยืนยันตัวตน",
    "locked": "ใส่ผิดหลายครั้งเกินไป บัญชีถูกพักไว้ชั่วคราว",
    "locked_retry": "ใส่ผิดหลายครั้งเกินไป — ลองใหม่ในอีก {{minutes}} นาที หรือติดต่อเจ้าของร้าน",
    "rate_limited": "ลองบ่อยเกินไปในเวลาสั้นๆ — รอสักครู่",
    "rate_limited_retry": "ลองบ่อยเกินไป — ลองใหม่ในอีก {{minutes}} นาที",
    "code_invalid": "รหัสไม่ถูกต้อง ดูแอปแล้วพิมพ์รหัสล่าสุด",
    "challenge_expired": "ขั้นตอนนี้ใช้เวลานานเกินไป เริ่มใหม่จากอีเมลและรหัสผ่าน",
    "weak_password": "ตั้งรหัสผ่านที่ยาวกว่านี้ (อย่างน้อย 12 ตัว และไม่ใช่รหัสที่ใช้กันทั่วไป)",
    "network": "เชื่อมต่อระบบร้านไม่ได้ — ตรวจการเชื่อมต่ออินเทอร์เน็ต",
    "unknown": "เข้าสู่ระบบไม่สำเร็จ ลองอีกครั้ง"
  },
  "invite": {
    "title": "ตั้งรหัสผ่านของคุณ",
    "intro": "ยินดีต้อนรับ {{name}} — คุณเข้าระบบด้วย {{email}}",
    "two_step": "หลังตั้งรหัสผ่าน จะตั้งการเข้าระบบ 2 ขั้นด้วยแอปยืนยันตัวตนในมือถือ — เตรียมมือถือไว้ด้วย",
    "valid_until": "ลิงก์นี้ใช้ได้ครั้งเดียว ถึง {{until}} (เวลาญี่ปุ่น)",
    "submit": "บันทึกแล้วไปต่อ",
    "missing": "ลิงก์ไม่ครบ — เปิดลิงก์จากอีเมลคำเชิญอีกครั้ง",
    "used_or_expired": "ลิงก์คำเชิญนี้ใช้ไปแล้วหรือหมดอายุ — ขอให้เจ้าของร้านส่งคำเชิญอีกครั้ง",
    "sign_in_now": "บันทึกรหัสผ่านแล้ว — เข้าระบบด้วยอีเมลและรหัสผ่านใหม่",
    "to_login": "ไปหน้าเข้าระบบ"
  }
}
